import moment from 'moment';

export default function FromNow(props) {
    const localDateTime = moment.utc(props.value).tz(moment.tz.guess());

    return localDateTime.isSame(moment(), 'day') ? 'Today' : localDateTime.isSame(moment().subtract(1, 'day'), 'day') ? 'Yesterday' : localDateTime.format('MMM D, YYYY');
}
